
import DeliveryEssentialsTemplate from "../../template/delivery essentials/delivery_essentials";
import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../../styles/Prescription.scss";

export default function DeliveryEssentials(props){
    const sideactive = useSelector((state) => state.counter.sidebarnav);
    const prescriptionType = useSelector(
      (state) => state.counter.prescriptionType
    );
    const patientId = useSelector((state) => state.counter.patientid);
  
    return(
        <>
        <div
          className={
            sideactive ? "maincontainer-patient-sa" : "maincontainer-patient"
          }
        >
          <div className="patient-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">Delivery Essentials</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a
                      href="/"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      Dashboard /
                    </a>
                    <a
                      href="/patientreports"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      &nbsp;Patient Reports
                    </a>
                  </li>
                  <li className="breadcrumb-item active">Delivery Essentials</li>
                </ul>
              </div>
            </div>
            <DeliveryEssentialsTemplate
            loaderchange={props.loaderchange}
            patientId={patientId}
            popupalert={props.popupalert}
            popuptext={props.popuptext}
            />
  
          </div>
        </div>
      </>
    )
}